var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex flex-col p-4" },
    [
      _c(
        "form-item",
        { attrs: { label: "Search" } },
        [
          _c("Input", {
            attrs: { placeholder: "Search Artist name" },
            model: {
              value: _vm.filter,
              callback: function($$v) {
                _vm.filter = $$v
              },
              expression: "filter"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex w-full mb-3" },
        [
          _c("Button", {
            staticClass: "w-full",
            attrs: { variant: "primary", label: "Search" },
            on: { clicked: _vm.search }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "data-tables-server",
        {
          ref: "tableArtist",
          attrs: {
            data: _vm.list,
            total: _vm.total,
            "pagination-props": {
              background: true,
              pageSizes: [_vm.displayingItem]
            }
          },
          on: { "query-change": _vm.onChangeTable }
        },
        [
          _vm._l(_vm.titles, function(title) {
            return _c("el-table-column", {
              key: title.prop.field,
              attrs: {
                prop: title.prop.field,
                label: title.label,
                sortable: "custom"
              }
            })
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Actions", align: "right", "min-width": "100px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      {
                        staticClass:
                          "static inline-block text-left container-action"
                      },
                      [
                        _c(
                          "VueCustomTooltip",
                          {
                            attrs: {
                              label: !scope.row.added ? "Add" : "Remove",
                              position: "is-left"
                            }
                          },
                          [
                            !scope.row.added
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "p-2 rounded bg-blue-700 text-blue-100 hover:bg-blue-100 hover:text-blue-700 border duration-200 ease-in-out\n                        border-blue-600 transition focus:outline-none",
                                    on: {
                                      click: function($event) {
                                        return _vm.addArtistTo(scope.row, true)
                                      }
                                    }
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: ["fa", "plus"] }
                                    }),
                                    _vm._v(" Add\n            ")
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.added
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "p-2 rounded bg-blue-100 text-blue-700 hover:bg-blue-700 hover:text-blue-100 border duration-200 ease-in-out\n                        border-blue-600 transition focus:outline-none",
                                    on: {
                                      click: function($event) {
                                        return _vm.addArtistTo(scope.row, false)
                                      }
                                    }
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: ["fa", "check"] }
                                    }),
                                    _vm._v(" Remove\n            ")
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6eb77b85", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eb77b85","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/AppSetting/SearchArtist.vue
// module id = null
// module chunks = 